import { styled, Typography } from '@mui/material';

export const Section = styled('section')(() => ({
  position: 'relative',
  width: '100%',
}));

export const Grid = styled('div')(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'minmax(0, 1.4113fr) minmax(0, 1fr)',
  gap: '20px',
  width: '100%',

  [theme.breakpoints.down('2xl')]: {
    gridTemplateColumns: 'minmax(0, 1.42223fr) minmax(0, 1fr)',
    gap: '16px',
  },
  [theme.breakpoints.down('xl')]: {
    gridTemplateColumns: 'repeat(2, 1fr)',
  },
  [theme.breakpoints.down('lg')]: {
    gridTemplateColumns: '1fr',
  },
}));

export const SideList = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '20px',
  minWidth: 0,
  height: '100%',

  [theme.breakpoints.down('2xl')]: {
    gap: '16px',
  },
  [theme.breakpoints.down('lg')]: {
    height: 'auto',
  },
}));

const cardBase = (theme) => ({
  position: 'relative',
  borderRadius: '24px',
  overflow: 'hidden',
  backgroundColor: theme.palette.color.global.card,
  transition: 'background-color var(--transition-ease-default)',

  '&:hover': {
    backgroundColor: theme.palette.color.surface.modalTetriaryHover,
  },
});

const sideCardBase = (theme) => ({
  ...cardBase(theme),
  display: 'flex',
  flex: 1,
  color: theme.palette.color.fg.primary,
  paddingLeft: '38.03%',

  [theme.breakpoints.down('2xl')]: {
    paddingLeft: '38.401%',
  },
  [theme.breakpoints.down('lg')]: {
    flex: 'none',
    height: 'auto',
    paddingLeft: '30%',
  },
  [theme.breakpoints.down('sm')]: {
    paddingLeft: '38%',
  },
});

export const FeaturedCard = styled('a')(({ theme }) => ({
  ...cardBase(theme),
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  color: theme.palette.color.fg.primary,

  [theme.breakpoints.down('lg')]: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    height: 'auto',
    paddingLeft: '30%',
  },
  [theme.breakpoints.down('sm')]: {
    paddingLeft: '38%',
  },
}));

export const SideCard = styled('a')(({ theme }) => ({
  ...sideCardBase(theme),
}));

export const SideCardStatic = styled('article')(({ theme }) => ({
  ...sideCardBase(theme),
}));

export const FeaturedImage = styled('img')(({ theme }) => ({
  height: '416px',
  objectFit: 'cover',

  [theme.breakpoints.down('2xl')]: {
    height: '324px',
  },
  [theme.breakpoints.down('lg')]: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '30%',
    height: '100%',
  },
  [theme.breakpoints.down('sm')]: {
    width: '38%',
  },
}));

export const SideImage = styled('img')(({ theme }) => ({
  position: 'absolute',
  top: 0,
  left: 0,
  width: '38.03%',
  height: '100%',
  objectFit: 'cover',

  [theme.breakpoints.down('2xl')]: {
    width: '38.401%',
  },
  [theme.breakpoints.down('lg')]: {
    width: '30%',
  },
  [theme.breakpoints.down('sm')]: {
    width: '38%',
  },
}));

export const FeaturedContent = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  flex: '1 1 auto',
  gap: '20px',
  padding: '28px',

  [theme.breakpoints.down('2xl')]: {
    gap: '16px',
    padding: '24px',
  },
  [theme.breakpoints.down('md')]: {
    gap: '12px',
    padding: '16px',
  },
}));

export const SideContent = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  flex: '1 1 auto',
  gap: '16px',
  minWidth: 0,
  padding: '28px',

  [theme.breakpoints.down('2xl')]: {
    gap: '12px',
    padding: '24px',
  },
  [theme.breakpoints.down('md')]: {
    padding: '16px',
  },
}));

export const FeaturedHead = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  width: '100%',
}));

export const SideHead = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  width: '100%',
}));

export const Meta = styled(Typography)({});

export const FeaturedTitle = styled(Typography)(({ theme }) => ({
  display: '-webkit-box',
  WebkitLineClamp: 2,
  WebkitBoxOrient: 'vertical',
  overflow: 'hidden',
  lineHeight: '1.5 !important',

  [theme.breakpoints.down('lg')]: {
    fontSize: '18px !important',
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: '16px !important',
  },
}));

export const SideTitle = styled(Typography)(() => ({
  fontSize: '20px',
  display: '-webkit-box',
  WebkitLineClamp: 2,
  WebkitBoxOrient: 'vertical',
  overflow: 'hidden',
}));

export const FeaturedText = styled(Typography)(() => ({
  display: '-webkit-box',
  WebkitLineClamp: 2,
  WebkitBoxOrient: 'vertical',
  overflow: 'hidden',
}));

export const SideText = styled(Typography)(({ theme }) => ({
  display: '-webkit-box',
  WebkitLineClamp: 1,
  WebkitBoxOrient: 'vertical',
  overflow: 'hidden',

  [theme.breakpoints.down('lg')]: {
    WebkitLineClamp: 2,
  },
}));
